import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';

type TextContentProps = {
  content: string;
};

function TextContent({ content }: TextContentProps) {
  return (
    <Stack gap="xxlarge" paddingBottom="large">
      <Text>{content}</Text>
    </Stack>
  );
}

export default TextContent;
